<script>
import toast from '@/utils/toast'
import request from '@/utils/request'
import bus from 'vue3-eventbus'
import lottie from 'lottie-web'
import animationData from '@/assets/share_whatsapp.json'
import coin from '@/assets/coins-sy.json'

export default {
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.lottieRef,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    })
    
    // this.anim2 = lottie.loadAnimation({
    //   container: this.$refs.coinRef,
    //   renderer: 'svg',
    //   loop: true,
    //   autoplay: true,
    //   animationData:coin                   
    // })
  },
  methods: {
    copyText(text) {
      if (navigator.clipboard) {
        toast.show('copy share link success')
        return navigator.clipboard.writeText(text)
      } else {
        return this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      return Promise.resolve()
    },
    shareWhatsapp () {
      this.$store.commit('shareTip', false)
      const whatsApp = this.getShareDataByPkg('com.whatsapp')
      if (!whatsApp) {
        return
      }
      this.reportShare('WA')

      setTimeout(() => {
        bus.emit('refresh', true)
      }, 2000)
      if (window.jskit) {
        window.jskit.share('com.whatsapp', JSON.stringify(whatsApp))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.whatsapp',
          link: whatsApp.link
        })
        return
      }
      let _href = 'https://api.whatsapp.com/send?'
      const text = whatsApp.link
      const link = whatsApp.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&img=' + encodeURIComponent(link)
      window.open(_href)
    },
    sharaFB () {
      this.$store.commit('shareTip', false)
      const fb = this.getShareDataByPkg('com.facebook.katana')
      if (!fb) {
        return
      }
      this.reportShare('FB')
      if (window.jskit) {
        window.jskit.share('com.facebook.katana', JSON.stringify(fb))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.facebook.katana',
          link: fb.link
        })
        return
      }
      console.log(fb.link)
      const _href = 'https://www.facebook.com/sharer/sharer.php?u=' + fb.link
      window.open(_href)
    },
    shareyoutube () {
      this.$store.commit('shareTip', false)
      const youtube = this.getShareDataByPkg('com.google.android.youtube')
      if (!youtube) {
        return
      }
      this.reportShare('Youtube')
      if (window.jskit) {
        window.jskit.share('com.google.android.youtube', JSON.stringify(youtube))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.google.android.youtube',
          link: youtube.link
        })
        return
      }
      const _href = 'vnd.youtube://youtube.com'
      window.open(_href)
      console.log('shareyoutube')
    },
    shareTelegram () {
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('org.telegram.messenger')
      if (!shareData) {
        return
      }
      this.reportShare('Tel')
      if (window.jskit) {
        window.jskit.share('org.telegram.messenger', JSON.stringify(shareData))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'org.telegram.messenger',
          link: shareData.link
        })
        return
      }
      let _href = 'https://t.me/share/url?'
      const text = shareData.link
      const link = shareData.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&url=' + encodeURIComponent(link)
      window.open(_href)
    },

    shareToIns () {
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('com.instagram.android')
      if (!shareData) {
        return
      }
      this.copyText(shareData.link)
      this.reportShare('Ins')
      if (window.jskit) {
        window.jskit.share('com.instagram.android', JSON.stringify(shareData))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.instagram.android',
          link: shareData.link
        })
        return
      }
      let _href = 'https://www.instagram.com/?'
      const text = shareData.link
      const link = shareData.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&url=' + encodeURIComponent(link)
      window.open(_href)
    },



    shareSystem () {
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('default')
      if (!shareData) {
        return
      }
      this.reportShare('other')
      if (window.jskit) {
        window.jskit.share('system', JSON.stringify(shareData))
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: '',
          link: shareData.link
        })
        return
      }
      if (navigator.canShare) {
        navigator.share({
          title: 'Share',
          text: shareData.link
        })
      } else {
        toast.show('Your browser does not support sharing')
      }
    },
    getShareDataByPkg (pkg) {
      const shareData = this.$store.state.shareData
      for (const index in shareData) {
        const item = shareData[index]
        if (item.platform === pkg) {
          return item
        }
      }
    },
    copyTxt () {
      const value = this.$store.state.linkUrl
      if (navigator.clipboard !== undefined && navigator.clipboard && window.isSecureContext) {
        toast.show('copy success')
        navigator.clipboard.writeText(value)
      } else {
        this.copy2(value)
      }
    },
    reportShare (platform) {
      request.post(`/landscape/task/share?code=${this.$store.state.code}&pn=${this.$store.state.pn}&platform=${platform}`, {})
    },

    copy2 (value) {
      const textArea = document.createElement('textarea')
      textArea.value = value
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      /* eslint-disable no-new */
      new Promise(() => {
        toast.show('copy success')
        document.execCommand('copy')
        textArea.remove()
      })
    }
  }
}
</script>

<template>
  <div class="share-bg">
  <div class="shimmer">
    <div id="share_top">
      <img src="../assets/share_gift.png">
      <div id="share_link">
        <span>Link:</span>
        <span>{{ $store.state.linkUrl }}</span>
        <div id="btn_copy" @click="copyTxt"></div>
      </div>
    </div>
    <div id="share_items">
      <div ref="lottieRef" class="iv_whatsapp" @click="shareWhatsapp"></div>
      <div class="iv_telegram"  @click="shareTelegram"></div>
      <div class="iv_fb"  @click="sharaFB"></div>
      <div class="iv_ins"  @click="shareToIns"></div>
      <div class="iv_system"  @click="shareSystem"></div>
      <!-- <div class="tips" v-show="$store.state.finish_task_count == 0">
        <div>$ 5</div>
      </div> -->
    </div>
    <div ref="coinRef" class="share-outline"></div>
  </div>
  </div>
</template>

<style scoped>

.share-bg {
  width: 100%;
  height: 26.2rem;
  background-image: url("../assets/share_bg.png");
  background-position: center;
  margin-top: 1rem;
  justify-items: center;
  display: flex;
  position: relative;
  flex-direction: column;
  background-size: 100% 100%;
  overflow: hidden;
}

.shimmer {
  width: 100%;
  height: 26.2rem;
  background-position: center;
  padding: 0 1rem;
  justify-items: center;
  display: flex;
  position: relative;
  flex-direction: column;
  background-size: 100% 100%;
  overflow: hidden;
  border-radius: 16px;
}

/* 扫光层 */
.shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 50%;
  height: 100%;

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.6),
    transparent
  );

  animation: shine 1.5s infinite;
}

@keyframes shine {
  100% {
    left: 150%;
  }
}

#share_top {
  height: 13.2rem;
  display: flex;
  align-items: center;
}

#share_top > img {
  height: 11rem;
  width: 48.3rem;
}

#share_link {
  background-image: url("../assets/bg_share_link.png");
  background-size: cover;
  height: 6rem;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 1rem 0 2.4rem;
}


#share_top > div :first-child {
  color: rgba(255, 255, 255);
  font-size: 2.4rem;
}

#share_top > div :nth-child(2) {
  color: rgb(255, 255, 255);
  padding-left: 1rem;
  font-size: 2.4rem;
  flex: 1;
}

#btn_copy {
  background-image: url("../assets/iv_copy.png");
  background-size: cover;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 5.3rem;
  width: 11rem;
  border-radius: 0.6rem;
}

#btn_copy:active {
  opacity: 0.6;
}

#btn_copy > p {
  align-self: center;
  color: rgb(255, 255, 255);
  font-size: 2.8rem;
}

#share_items {
  width: 100%;
  height: 13rem;
  align-items: center;
  display: flex;

}

.iv_whatsapp {
  width: 34.5rem;
  height: 12.7rem;
  margin-bottom: 1rem;
  /* background-image: url("@/assets/share_whatsapp.png");
  background-size: contain;
  background-repeat: no-repeat; */
}

.iv_whatsapp:active {
  opacity: 0.6;
}

.iv_fb {
  width: 20.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_fb.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.iv_fb:active {
  opacity: 0.6;
}

.iv_youtube {
  width: 20.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_fb.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.iv_telegram {
  width: 20.7rem;
  height: 12.7rem;
  background-image: url("@/assets/share_telegram.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.iv_ins {
  width: 20.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_ins.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.tips {
  position: absolute;
  height: 6.5rem;
  width: 12rem;
  left: 23rem;
  bottom: 8rem;
  background: url("@/assets/share_red_tip.png");
  background-size: 100% 100%;
}

.tips div {
  position: absolute;
  font-size: 2.4rem;
  left: 4.6rem;
  color: #FBEB6E;
  font-weight: bolder;
  top: 1.1rem;
  text-shadow: 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C;

}

.iv_youtube:active {
  opacity: 0.6;
}

.iv_system {
  width: 12.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_more.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.iv_system:active {
  opacity: 0.6;
}


/* @media screen and (orientation: portrait) {
  .share-outline {
    height: 100vw;
    width: 169vw;
    background-image: url("@/assets/main_share_outline.png");
    background-size: 100% 100%;
    position: absolute;
    pointer-events: none;
    bottom: 0;
    left: -1%;
  }
}

@media screen and (orientation: landscape) {
  .share-outline {
    width: 169vh;
    height: 95vh;
    background-image: url("@/assets/main_share_outline.png");
    background-size: 100% 100%;
    position: absolute;
    pointer-events: none;
    bottom: 0;
    left: -1%;
  }
} */

.share-outline {
  width: 102%;
  height: 100%;
  background-image: url("@/assets/main_share_outline.png");
  background-size: 100% 100%;
  position: absolute;
  pointer-events: none;
  bottom: 0;
  left: -1%;
}
</style>
